import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import blogs from '../../api/blogs';

const BlogList = () => {
    const { t, i18n } = useTranslation();
    const isEnglish = (i18n.resolvedLanguage || i18n.language || 'tr').startsWith('en');
    const organizationUnits = ['culture', 'art', 'sport', 'social', 'international'];
    const [searchParams] = useSearchParams();
    const requestedUnit = searchParams.get('unit');
    const activeUnit = organizationUnits.includes(requestedUnit) ? requestedUnit : null;
    const publishedBlogs = blogs.filter((blog) => blog.unit);
    const visibleBlogs = activeUnit
        ? publishedBlogs.filter((blog) => blog.unit === activeUnit)
        : publishedBlogs;

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    const createExcerpt = (description) => {
        if (!description || description.length <= 420) return description;
        return `${description.slice(0, 420).trim()}…`;
    };

    return (
        <section className="donation sitePageSection">
            <div className="container">
                <div className="sitePageHeading">
                    <h1>{t('blog.pagesub')}</h1>
                </div>
                <div className="blogOrganization mb-55">
                    <h2 className="blogOrganization__title">{t('blog_sidebar.organization')}</h2>
                    <nav className="blogOrganization__tabs" aria-label={t('blog_sidebar.organization')}>
                        {organizationUnits.map((unit) => (
                            <Link
                                className={`blogOrganization__tab${activeUnit === unit ? ' active' : ''}`}
                                key={unit}
                                to={`/blog?unit=${unit}`}
                                aria-current={activeUnit === unit ? 'page' : undefined}
                            >
                                {t(`units.${unit}`)}
                            </Link>
                        ))}
                    </nav>
                </div>

                <div className="blogListFlow">
                    {visibleBlogs.map((blog) => {
                        const title = isEnglish && blog.titleEn ? blog.titleEn : blog.title;
                        const description = isEnglish && blog.descriptionEn ? blog.descriptionEn : blog.description;
                        const date = isEnglish && blog.createAtEn ? blog.createAtEn : blog.create_at;

                        return (
                        <article className="eventsBlock blogListItem" key={blog.id}>
                            <figure className="eventsBlock__thumb">
                                <Link
                                    onClick={ClickHandler}
                                    to={`/blog-details/${blog.slug}`}
                                    className="blogListItem__imageLink"
                                    aria-label={title}
                                >
                                    <img
                                        src={blog.screens}
                                        alt={title}
                                        className="eventsBlock__thumb__image"
                                    />
                                </Link>
                            </figure>

                            <div className="eventsBlock__content">
                                <div className="blogListItem__meta">
                                    <span>{date}</span>
                                    <span aria-hidden="true">•</span>
                                    <span>{blog.author}</span>
                                </div>
                                <h2 className="eventsBlock__heading">
                                    <Link onClick={ClickHandler} to={`/blog-details/${blog.slug}`}>
                                        {title}
                                    </Link>
                                </h2>
                                <p className="eventsBlock__text">{createExcerpt(description)}</p>
                            </div>
                        </article>
                    )})}
                    {visibleBlogs.length === 0 && (
                        <div className="blogListEmpty" role="status">
                            <h2>{t(`units.${activeUnit}`)}</h2>
                            <p>{t('blog.empty_unit')}</p>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default BlogList;
